define([
    'vue',
    'web/i18n/index',
    'WebCommon/mixin/page',
    'vueRouter',
    'product-detail2024/page/page-content'
], function(
    Vue,
    i18n,
    PageMixin,
    VueRouter,
    PageContent
){
    Vue.use(VueRouter);

    var routes = [
        { path: '*', component: PageContent }
    ];
    var router = new VueRouter({
        routes: routes,
        mode: 'history',
        base: '/'
    });

    var app = new Vue({
        mixins: [PageMixin],
        router: router,
        i18n: i18n
    });
    app.$mount('#app');
});



//////////////////
// WEBPACK FOOTER
// ./product-detail2024/main.js
// module id = 192
// module chunks = 0